import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import "./dispositifsIndividuels.scss"
import ButtonsContainer from 'components/buttons/buttonsContainer'
export default function DispositifsIndividuels({routes}) {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Les dispositifs individuels",
            icon : "picto_dispositifs_individuels.svg",
            color : "bckRed"
        })
    }, [])
    const buttons = [
        {
            title : "Les études promotionnelles",
            icon : "picto_etudes_promotionnelles.svg",
            buttonBackground : "bckRed80",
            page : "/accueil/parcours_evolution/etudes_promotionnelles",
            right : "600px",
            delay : "0"
        },
        {
            title : "Le compte personnel de formation",
            icon : "picto_compte_personnel_formation.svg",
            buttonBackground : "bckRed80",
            page : "/accueil/parcours_evolution/cpf",
            left : "600px",
            delay : "0"
        },
        {
            title : "La validation des acquis de l'expérience",
            icon : "picto_validation_acquis_experience.svg",
            buttonBackground : "bckRed80",
            page : "/accueil/parcours_evolution/vae",
            right : "600px",
            delay : "100"
        },
        {
            title : "Le bilan de compétence",
            icon : "picto_bilan_de_competence.svg",
            buttonBackground : "bckRed80",
            page : "/accueil/parcours_evolution/bilan_competence",
            left : "600px",
            delay : "100"
        },
        {
            title : "Le congé de formation professionnelle",
            icon : "picto_conge_formation.svg",
            buttonBackground : "bckRed80",
            page : "/accueil/parcours_evolution/cfp",
            top : "600px",
            delay : "200"
        },
    ]
    return (
        <div className="w100 h100" id="dispositifsIndividuels">
            <div className='w100' style={{padding : "100px"}}>
                <ButtonsContainer buttons={buttons}/>
            </div>        
        </div>
    )
}
